module.exports = __webpack_public_path__ + "img/cptx4@2x.3d251572.png";